<template>
  <div class="bg-base-100 w-96">
    <h1
      class="title tooltip tooltip-bottom"
      data-tip="Change display style of keyboard keys"
    >
      Keycap style
    </h1>

    <div class="flex flex-col">
      <ToggleOption
        label="Use Icons"
        tooltip="Show key icons when possible"
        v-model="kc.use_icons"
      />
      <ToggleOption
        label="Use Mac Shift"
        tooltip="Use Mac icon for the Shift key"
        v-model="kc.use_mac_shift"
        :disabled="!kc.use_icons"
      />
      <ToggleOption
        label="Use Mac Ctrl"
        tooltip="Use Mac Control icon for the Ctrl key"
        v-model="kc.use_mac_ctrl"
        :disabled="!kc.use_icons"
      />
      <ToggleOption
        label="Use Mac GUI"
        tooltip="Use Mac Command icon for GUI/Windows/Command/Super"
        v-model="kc.use_mac_gui"
        :disabled="!kc.use_icons"
      />
      <ToggleOption
        label="Use Mac Alt"
        tooltip="Use Mac Option icon for the Alt key"
        v-model="kc.use_mac_alt"
        :disabled="!kc.use_icons"
      />
      <ToggleOption
        label="Short Key Names"
        tooltip="Display short versions of key names when possible"
        v-model="kc.short_names"
      />

      <ToggleOption
        label="Show Hold/Tap keys"
        tooltip="Show Hold/Tap keys directly on the keycap"
        v-model="kc.show_hold_tap"
      />
      <ToggleOption
        label="Use Hold/Tap icons"
        tooltip="Show icons instead of 'H'/'T' when displaying Hold/Tap"
        v-model="kc.use_hold_tap_icons"
      />
      <ToggleOption
        label="Advanced Consumer keys"
        tooltip="Enable all USB HID Consumer Page keys instead of only Media (some keys may not work)"
        v-model="kc.advanced_consumer_keys"
      />

      <h1 class="title">Other</h1>
      <SettingsOption
        label="Notification timeout"
        tooltip="Time in seconds until notifications disappear. If set to 0 then notifications will disappear only when clicked."
      >
        <div class="join w-min">
          <IntegerInput
            class="w-[9ch] input-sm join-item"
            :min="0"
            v-model="toastSettings.timeout_sec"
          />
          <span class="join-item btn-input-unit btn-input-unit-sm">sec</span>
        </div>
      </SettingsOption>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useKeycapStore, useToastStore } from "@/stores";
import IntegerInput from "@/components/utils/IntegerInput.vue";
import SettingsOption from "@/components/utils/SettingsOption.vue";
import ToggleOption from "@/components/settings/ToggleOption.vue";

const toastSettings = useToastStore();
const kc = useKeycapStore();
</script>

<style scoped>
.title {
  @apply block text-lg text-center mt-5 mb-1 py-1;
}
</style>
